import { GeoCoordinates } from './../location';

export interface FitterGoogleData {
  place_id: string;
  name?: string;
  location?: GeoCoordinates;
  rating?: number;
  formatted_address?: string;
  formatted_phone_number?: string;
  international_phone_number?: string;
  business_status?: string;
  website?: string;
  user_ratings_total?: number;
  review?: {
    author_name: string;
    author_url: string;
    language: string;
    profile_photo_url: string;
    rating: 5;
    relative_time_description: string;
    text: string;
    time: number;
  }[];
}

export interface GoogleOpeningHoursInfos {
  periods: GoogleOpeningPeriod[];
}

export interface GoogleOpeningPeriod {
  close: GoogleOpeningLimit;
  open: GoogleOpeningLimit;
}

export interface GoogleOpeningLimit {
  day: number;
  time: string;
}
